<app-entity-overview #overviewComponent
                            [entityOverviewBaseComponent]="this"
                            [isEmbedded]="true"
                            [stereotyped]="true"
                            detailLink="masterdata/contacts"
                            module="management">
</app-entity-overview>
